
import history from 'store/history'
import { BrowserRouter } from 'react-router-dom'


export default class Router extends BrowserRouter {
  history = history
}
